import { render, staticRenderFns } from "./AlterarDadosUsuarios.vue?vue&type=template&id=78813aca&scoped=true&"
import script from "./AlterarDadosUsuarios.vue?vue&type=script&lang=js&"
export * from "./AlterarDadosUsuarios.vue?vue&type=script&lang=js&"
import style0 from "./AlterarDadosUsuarios.vue?vue&type=style&index=0&id=78813aca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78813aca",
  null
  
)

export default component.exports